// extracted by mini-css-extract-plugin
export default {"burgerButton":"burger-button-module--burgerButton--b4b36"};